export const reviewsTableHeaders = [
  {
    name: "name",
    label: "Entry",
    style: { width: "15%" },
  },
  {
    name: "open",
    label: "Opened",
    style: { width: "15%" },
  },
  {
    name: "date",
    label: "Entry Date",
    style: { width: "15%" },
  },
  {
    name: "verify",
    label: "Yacht Verified",
    style: { width: "15%" },
  },
  {
    name: "cosign",
    label: "Co Signer",
    style: { width: "15%" },
  },
  {
    name: "status",
    label: "Status",
    style: { width: "15%" },
  },
  {
    name: "blank",
    label: "",
    style: { width: "0%" },
  },
];
